import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";
function EditarusuarioWrapper(props) {
    const params = useParams();
   return <Editarusuario {...props} params={params} />;
}

class Editarusuario extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            id:"",
            idusuario: "",
            nombres:"",
            apellidos:"",
            usuario: "",
            nochapa:"",
            rol:"",
            estado:"",
            mensaje: "",
            redireccionar: false
        };
    }

    cambioValor = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

componentDidMount() {
    const id = this.props.params.id;

    fetch(api + `usuarios/${id}`, {
        headers: authHeaders()
    })
    .then(respuestausuario => respuestausuario.json())
    .then((datosRespuestausuario) => {

       

        const usuario = datosRespuestausuario[0];

        this.setState({
            datosCargadosusuario: true,
            idusuario: usuario.idusuario,
            usuario: usuario.usuario,
            nombres: usuario.nombres,
            apellidos: usuario.apellidos,
            nochapa: usuario.nochapa,
            rol: usuario.rol,
            estado: usuario.estado,
        });
    })
    .catch(error => {
        
        this.setState({
            datosCargadosusuario: true,
            mensaje: "Error al cargar datos del usuario"
        });
    });
}

    enviarDatosusuario = (e) => {
    e.preventDefault();

    const { idusuario, nombres, apellidos, usuario, nochapa, rol, estado } = this.state;

    const datosEnviarusuario = {
        nombres,
        apellidos,
        usuario,
        nochapa,
        rol,
        estado
    };

    fetch(api + `usuarios/${idusuario}`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(datosEnviarusuario)
    })
    .then(respuestausuario => respuestausuario.json())
    .then((datosRespuestausuario) => {
        if (datosRespuestausuario.success === 1) {
            this.setState({
                mensaje: "Usuario actualizado con éxito"
            });

            setTimeout(() => {
                this.setState({
                    redireccionar: true
                });
            }, 2000);
        } else {
            this.setState({
                mensaje: datosRespuestausuario.mensaje || "No se pudo actualizar el usuario"
            });
        }
    });
}


enviarDatosusuario1 = (e) => {
        e.preventDefault();

        const { idusuario, nombres, apellidos, usuario, nochapa,  rol, estado } = this.state;

        const datosEnviarusuario1 = {
            idusuario: idusuario,
            nombres: nombres,
            apellidos: apellidos,
            usuario: usuario,
            nochapa:nochapa,
            rol: rol,
            estado: estado,
        };

        fetch(api+"usuarios.php?actualizarvadmin=1", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(datosEnviarusuario1)
        })
            .then(respuestausuario1 => respuestausuario1.json())
            .then((datosRespuestausuario1) => {
           

                this.setState({
                    mensaje: "Usuario actualizado con éxito"
                });

                setTimeout(() => {
                    this.setState({
                        redireccionar: true
                    });
                }, 2000);
            })
            
    }


    render() {
        const { datosCargadosusuario, usuario, nombres, apellidos, nochapa,  rol, estado, mensaje, redireccionar } = this.state;

        if (redireccionar) {
            return <Navigate to="/usuarios"/>;
        }

        return (
            <div className="card">
                <div className="card-header">
                    Editar Usuarios
                </div>

                <div className="card-body">
                    {mensaje && (
                        <div className="alert alert-success" role="alert">
                            {mensaje}
                        </div>
                    )}

                    {datosCargadosusuario ? (
                        <form onSubmit={this.enviarDatosusuario}>

                            <div className="form-group">
                                <label htmlFor="idusuario">ID</label>
                                 <input
                                    type="text"
                                    name="idusuario"
                                    value={this.state.idusuario}
                                    id="idusuario"
                                    className="form-control"
                                    readOnly
                                />
                                 <small className="text-muted">
                                 ID del usuario (no editable)
                                 </small>
                                </div>

                                <div className="form-group">
                                <label htmlFor="nombres">Nombres</label>
                                <input
                                    type="text"
                                    name="nombres"
                                    onChange={this.cambioValor}
                                    value={nombres}
                                    id="nombres"
                                    className="form-control"
                                    placeholder=""
                                    aria-describedby="helpNombres"
                                />
                                <small id="helpNombres" className="text-muted">
                                    Escribe los nombres del usuario 
                                </small>
                            </div>

                            <div className="form-group">
                                <label htmlFor="apellidos">Apellidos</label>
                                <input
                                    type="text"
                                    name="apellidos"
                                    onChange={this.cambioValor}
                                    value={apellidos}
                                    id="apellidos"
                                    className="form-control"
                                    placeholder=""
                                    aria-describedby="helpApellidos"
                                />
                                <small id="helpApellidos" className="text-muted">
                                    Escribe los apellidos del usuario 
                                </small>
                            </div>

                            <div className="form-group">
                                <label htmlFor="usuario">Usuario</label>
                                <input
                                    type="text"
                                    name="usuario"
                                    onChange={this.cambioValor}
                                    value={usuario}
                                    id="usuario"
                                    className="form-control"
                                    placeholder=""
                                    aria-describedby="helpUsuario"
                                />
                                <small id="helpusuario" className="text-muted">
                                    Escribe el usuario 
                                </small>
                            </div>

                            <div className="form-group">
                                <label htmlFor="nochapa">No. Chapa</label>
                                <input
                                    type="text"
                                    name="nochapa"
                                    onChange={this.cambioValor}
                                    value={nochapa}
                                    id="nochapa"
                                    className="form-control"
                                    placeholder=""
                                    aria-describedby="helpNochapa"
                                />
                                <small id="helpNochapa" className="text-muted">
                                    Escribe el Número de chapa del usuario 
                                </small>
                            </div>




                            <div className="form-group">
                                 <label htmlFor="rol">Rol del empleado</label>

                                 <select
                                    name="rol"
                                    onChange={this.cambioValor}
                                    value={String(rol)}
                                    id="rol"
                                    className="form-control"
                                    aria-describedby="helpRol"
                                 >
                                    <option value="">Seleccione un rol</option>
                                    <option value="1">Administrador</option>
                                    <option value="2">Secretaria</option>
                                    <option value="3">Agente</option>
                                </select>

                                    <small id="helpRol" className="text-muted">
                                    Selecciona el Rol del empleado
                                    </small>
                            </div>

                            <div className="form-group">
                                 <label htmlFor="rol">Estado del empleado</label>

                                 <select
                                    name="estado"
                                    onChange={this.cambioValor}
                                    value={String(estado)}
                                    id="rol"
                                    className="form-control"
                                    aria-describedby="helpRol"
                                 >
                                    <option value="">Seleccione un estado</option>
                                    <option value="1">Activo</option>
                                    <option value="2">Inactivo</option>
                                    <option value="3">Suspendido</option>
                                </select>

                                    <small id="helpRol" className="text-muted">
                                    Selecciona el Estado del empleado
                                    </small>
                            </div>
                            <div className="btn-group" role="group" aria-label="">
                                <button type="submit" className="btn btn-success">
                                    Actualizar empleado
                                </button>

                                <Link to="/usuarios" className="btn btn-primary">
                                    Cancelar
                                </Link>

                                
                            </div>
                        </form>
                    ) : (
                        <p>Cargando datos...</p>
                    )}
                </div>

                <div className="card-footer text-muted">
                    PMT EN TODO
                </div>
            </div>
        );
    }
}

export default EditarusuarioWrapper;